// extracted by mini-css-extract-plugin
export default {"filterTag":"CustomFilters-ActiveFilterTag__filterTag--l9UV4"};